<template>
  <section>
    <b-row>
      <b-col md="12">
        <b-link :to="{ name: 'dinamicas' }">Regresar</b-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <h2>{{ encuesta.nombre }}</h2>
      </b-col>
    </b-row>
    <b-overlay :show="show" rounded="sm" variant="white">
      <b-row class="py-2">
        <b-col md="12">

          <h4 class="mt-1">Exportar {{ encuesta.nombre }}</h4>
          <h6>Permite exportar las respuestas de {{ encuesta.nombre }} en formato .Xlsx (Excel)</h6>
          <b-button class="mt-3" variant="success" @click.prevent="exportarXlsx">Exportar</b-button>

          <!-- <h4> -->
          <!-- <b-link href="" @click.prevent="exportarXlsx"><b-icon icon="file-spreadsheet"></b-icon> Exportar a excel</b-link> -->
          <!-- </h4> -->
        </b-col>
      </b-row>
    </b-overlay>
  </section>
</template>

<script lang="ts">
import axios from 'axios'
import { Vue, Component, Watch } from 'vue-property-decorator'

import { url } from '../../../services/url_service'

@Component
export default class Caracterizaciones extends Vue {
  public show: boolean = false
  public encuestaId?: number = null
  public encuesta: any = {}
  async exportarXlsx() {
    this.show = true
    try {
      let response = await axios.get(
        url.create(`/internal/dinamicas/${this.encuestaId}/respuestas/excel`),
        {
          params: {},
        }
      )
      this.show = false
      window.location.href = response.data.enlace
    } catch (ex) {
      this.$bvModal.msgBoxOk('No hay encuestas para descargar')
      this.show = false
    }
  }
  public async cargarEncuesta() {
    try {
      let response = await axios.get(
        url.create(`/internal/dinamicas/${this.encuestaId}`)
      )
      this.encuesta = response.data
    } catch (ex) {
      this.$router.replace({ name: 'dinamicas' })
    }
  }
  created() {
    this.encuestaId = parseInt(this.$route.params['id'])
    this.cargarEncuesta()
  }
}
</script>
